import { render, staticRenderFns } from "./BasicInformationC.vue?vue&type=template&id=31510ab5&"
import script from "./BasicInformationC.vue?vue&type=script&lang=js&"
export * from "./BasicInformationC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports